import { useMarkSeen, useSeenStatus } from "./SeenStatus.hook";
import React, { useContext } from "react";
import { Button, Popover } from "antd";
import { PlusOutlined, EyeFilled } from "@ant-design/icons";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import "./styles.less";

export function SeenIcon({
	id,
	type = "icon",
	onWatchAgain,
}: {
	id: string;
	type?: "icon" | "overlay";
	onWatchAgain?: () => void;
}) {
	const { country_code } = useContext(ConfigStateContext);
	const { result, loading } = useSeenStatus({ id });
	const { markSeen, loading: changeLoad } = useMarkSeen();

	const onClickSeenButton = () => {
		if (!result) {
			markSeen(id);
		}
		return false;
	};

	const handleOverlayClick = (e) => {
		if(country_code === "ce3" && e.target.tagName !== "SPAN") {
			const linkElement = e.target.previousElementSibling;
			linkElement.click();
		}
	}

	if (type == "overlay") {
		return result ? (
			<div className={"seen-overlay " + country_code } onClick={handleOverlayClick}>
				<span>Ya viste esta propiedad</span>
				{typeof onWatchAgain != "undefined" && (
					<Button onClick={onWatchAgain} size="small" type="ghost" >
						Ver de nuevo
					</Button>
				)}
			</div>
		) : null;
	}

	return (
		<Popover
			overlayClassName={"seen-button-popover"}
			content={result ? "Visto" : "Marcar como Visto"}
			placement={"right"}>
			<Button
				className="seen-button"
				onClick={onClickSeenButton}
				shape={"circle"}
				loading={changeLoad || loading}
				icon={result ? <EyeFilled /> : <PlusOutlined />}
				style={{ cursor: result ? "default" : "pointer" }}
			/>
		</Popover>
	);
}
